export const cardsKeys = {
  list: ["cards"],
};
